<cm-menu-item *ngFor="let item of menuItems" [menuItem]="item" [compact]="compact" (itemClick)="itemClick.emit($event)"></cm-menu-item>
